import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import { ToastProvider } from './components/layout/Toast';
import { App } from './App';
import { initCrashReporting } from './lib/crash';
import './index.css';

// Before render so even a first-paint crash is reported.
initCrashReporting();

// Apply the persisted theme before first paint to avoid a flash.
// Dark is native; `light`/`night` classes are variants; auto follows the OS.
try {
  const persisted = JSON.parse(localStorage.getItem('copapp-ui') || '{}');
  const theme: string = persisted?.state?.theme
    ?? (persisted?.state?.isDarkMode === false ? 'light' : 'dark');
  if (theme === 'light') document.documentElement.classList.add('light');
  else if (theme === 'night') document.documentElement.classList.add('night');
  else if (theme === 'auto' && window.matchMedia('(prefers-color-scheme: light)').matches) {
    document.documentElement.classList.add('light');
  }
} catch {
  // corrupted persistence — stay dark
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
